import { getTranslatedText } from '../utils/translate';

export const errorMessages: Record<string, { title: () => string; message: () => string }> = {
  INVALID_VERIFICATION_CODE: {
    title: getTranslatedText('회원가입이메일인증_잘못된코드_제목'),
    message: getTranslatedText('회원가입이메일인증_잘못된코드_내용'),
  },
  EXPIRED_VERIFICATION_CODE: {
    title: getTranslatedText('회원가입이메일인증_만료된코드_제목'),
    message: getTranslatedText('회원가입이메일인증_만료된코드_내용'),
  },
  COOLDOWN_LIMIT: {
    title: getTranslatedText('회원가입이메일인증_재발송쿨다운_제목'),
    message: getTranslatedText('회원가입이메일인증_재발송쿨다운_내용'),
  },
  DAILY_LIMIT_EXCEEDED: {
    title: getTranslatedText('회원가입이메일인증_일일한도초과_제목'),
    message: getTranslatedText('회원가입이메일인증_일일한도초과_내용'),
  },
};
